import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useLayoutEffect,
} from "react";
import { styled } from "@mui/material/styles";
import Aside from "../containers/Aside/Aside";
import WhiteLogo from "url:../../assets/images/WhiteLogo.png";
import test from "../../assets/images/lumen-logo.svg";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../common/components/Breadcrumb";
import AccountMenu from "./AccountMenu";
import PropTypes from "prop-types";
import HttpService from "../Dashboard/duck/HttpService";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { userOperations } from "../MyDetails/duck";

const PREFIX = "Header";

const classes = {
  mainHeader: `${PREFIX}-mainHeader`,
};

const Root = styled("header")({
  [`&.${classes.mainHeader}`]: {
    zIndex: 10,
    position: "fixed",
    borderBottom: "unset",
    width: "100%",
    height: 64,
    backgroundColor: "#00badb",
    marginBottom: 16,
    boxShadow:
      "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
  },
});

const Header = ({ authenticated, companyId, getUserData, location }) => {
  const isSuperUser = localStorage.getItem("superUser");
  const [companies, setCompanies] = useState();
  const [selectedCompany, setSelectedCompany] = useState();
  const [hideLogo, setHideLogo] = useState(false);

  const breadcrumbRef = useRef(null);
  const logoRef = useRef(null);

  const locationLength = location.pathname.split("/").length;

  useEffect(() => {
    if (!isSuperUser) return;

    const initialiseData = async () => {
      getUserData();
      const companies = await HttpService.getCompaniesList();
      setCompanies(companies.data);
    };

    initialiseData();
  }, [isSuperUser, getUserData]);

  useEffect(() => {
    if (!companies || !companyId) return;

    const companyInternalId = localStorage.getItem("companyInternalId");
    const hasCompanyInternalId =
      !!companyInternalId && companyInternalId !== "null";

    if (hasCompanyInternalId) {
      const selectedCompany = companies.find(
        ({ internal_id }) => internal_id === companyInternalId
      );
      setSelectedCompany(selectedCompany);
    } else {
      const selectedCompany = companies.find(({ id }) => id === companyId);
      setSelectedCompany(selectedCompany);
    }
  }, [companies, companyId]);

  const checkOverlap = useCallback(() => {
    const breadcrumbWrapper = breadcrumbRef.current;
    const logoEl = logoRef.current;
    
    const breadcrumbEl =
      breadcrumbWrapper?.firstElementChild || breadcrumbWrapper;

    if (!breadcrumbEl || !logoEl) {
      setHideLogo(false);
      return;
    }

    const breadcrumbRect = breadcrumbEl.getBoundingClientRect();
    const logoRect = logoEl.getBoundingClientRect();

    const isOverlapping = !(
      breadcrumbRect.right <= logoRect.left ||
      breadcrumbRect.left >= logoRect.right ||
      breadcrumbRect.bottom <= logoRect.top ||
      breadcrumbRect.top >= logoRect.bottom
    );

    setHideLogo(isOverlapping);
  }, []);

  useLayoutEffect(() => {
    checkOverlap();

    const handleResize = () => checkOverlap();
    window.addEventListener("resize", handleResize);

    let resizeObserver;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        checkOverlap();
      });

      const breadcrumbWrapper = breadcrumbRef.current;
      const breadcrumbEl =
        breadcrumbWrapper?.firstElementChild || breadcrumbWrapper;

      if (breadcrumbEl) resizeObserver.observe(breadcrumbEl);
      if (logoRef.current) resizeObserver.observe(logoRef.current);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, [checkOverlap, location.pathname, companies, selectedCompany]);

  const onCompanyChange = (company) => {
    setSelectedCompany(company);
    const isDefaultCompany = companyId === company.id;
    const companyInternalId = isDefaultCompany ? null : company.internal_id;
    localStorage.setItem("companyInternalId", companyInternalId);
    window.location.reload();
  };

  return (
    <Root className={classes.mainHeader}>
      <div
        ref={breadcrumbRef}
        style={{ display: "flex", alignItems: "center", flexGrow: 1 }}
      >
        <Breadcrumbs />
      </div>

      <img
        ref={logoRef}
        alt="Lumen logo"
        style={{
          position: "absolute",
          zIndex: 4,
          marginLeft: "auto",
          marginRight: "auto",
          left: 0,
          right: 0,
          top: 20,
          width: 120,
          visibility: hideLogo ? "hidden" : "visible",
        }}
        src={WhiteLogo}
      />

      {companies && isSuperUser && selectedCompany && (
        <TextField
          id="company"
          name="company"
          hiddenLabel
          variant="filled"
          select
          size="small"
          style={{
            backgroundColor: "#FFFFFF",
            position: "fixed",
            zIndex: 4,
            right: 360,
            top: 14,
            width: 240,
          }}
          value={selectedCompany}
          onChange={(e) => onCompanyChange(e.target.value)}
          disabled={locationLength > 2}
        >
          {companies.map((option, index) => {
            return (
              <MenuItem key={index} value={option}>
                {option.name}
              </MenuItem>
            );
          })}
        </TextField>
      )}

      {authenticated ? (
        <>
          <AccountMenu /> <Aside />
        </>
      ) : (
        ""
      )}
    </Root>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getUserData: () => dispatch(userOperations.getUserData()),
});

const mapStateToProps = (state) => {
  return {
    authenticated: state.userData.authenticated,
    companyId: state.userData.userData.company_id,
  };
};

Header.propTypes = {
  classes: PropTypes.object,
  authenticated: PropTypes.bool,
  companyId: PropTypes.number,
  getUserData: PropTypes.func,
  location: PropTypes.object,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));